import styled from 'styled-components';
import { ImageUtils } from '../../../../utils/ImageUtils';
import { useTextVariant } from '../../../../hook/useTextVariant';
import { OFFLINE_INFO_CONSTANTS } from '../../../../constants/offlineInfo';
import { tabletQuery } from '../../../../utils';

export const OfflineInfoPc = () => {
  const { getText } = useTextVariant(OFFLINE_INFO_CONSTANTS, false);

  return (
    <Container>
      <Item>
        <FullTextContainer>
          <FullText>{getText('fullText')}</FullText>
        </FullTextContainer>

        <Bg>
          <TitleContainer>
            <span>
              <img src={ImageUtils.ArrowRightIcon} />
            </span>
            <Title>{getText('titleHolder')}</Title>
            <span>
              <img src={ImageUtils.ArrowRightIcon} />
            </span>
          </TitleContainer>

          <Content>
            <CircleText>{getText('venue')}</CircleText>

            <LocationDesc>{getText('venueAddress')}</LocationDesc>
          </Content>

          <ContentWithDividers>
            <LocationTitle>{getText('eventDate')}</LocationTitle>
            <LocationDesc>{getText('entryTime')}</LocationDesc>
          </ContentWithDividers>

          <WaringContainer>
            <WaringText>{getText('warningTicket')}</WaringText>
          </WaringContainer>
        </Bg>

        <DetailContainer>
          <DetailText>{getText('detailInfo')}</DetailText>
        </DetailContainer>
      </Item>
    </Container>
  );
};

const Bg = styled.div`
  background: #1e1e1e;
  padding-top: 14px;
  padding-bottom: 14px;
`;

const FullTextContainer = styled.div`
  padding-bottom: 24px;
  padding-top: 24px;
  background: rgba(36, 35, 35, 0.67);
`;

const FullText = styled.h3`
  color: #3fb5ff;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
  line-height: 136.152%;
  letter-spacing: -0.88px;
`;

const DetailContainer = styled.div`
  margin-top: 24px;
`;

const DetailText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.64px;

  span {
    color: #fae100;
    font-weight: 600;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6.5%;
    text-underline-offset: 25%;
    text-underline-position: from-font;
    cursor: pointer;
  }
`;

const CircleText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  display: inline-block;

  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.88px;

  height: 38px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-radius: 30px;

  margin-right: 7px;
  padding-left: 20px;
  padding-right: 20px;
`;

const LocationTitle = styled.h4`
  color: rgba(255, 255, 255, 0.9);
  font-size: 22px;
  font-weight: 500;
  line-height: 24px;
  margin-right: 16px;
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 22px;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.88px;
  text-align: left;
  display: flex;
  align-items: center;
  border-radius: 40px;
  border: 3px solid rgba(255, 255, 255, 0.26);
  padding-left: 20px;
  padding-right: 20px;
  height: 50px;

  img {
    margin-right: 4px;
  }
`;

const LocationDesc = styled.h3`
  color: rgba(255, 255, 255, 0.6);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.8px;
`;

const Container = styled.div`
  flex: 1;
  padding-bottom: 100px;
`;

const Item = styled.div`
  margin-bottom: 20px;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2px;

  span img {
    margin-right: 18px;
  }

  span:last-child img {
    margin-left: 18px;
    transform: rotate(180deg);
    padding-bottom: 5px;
  }
`;

const Title = styled.h3`
  color: #fff;
  font-size: 20px;
  font-weight: 500;
`;

const Content = styled.div`
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 6px;
`;

const ContentWithDividers = styled(Content)`
  padding-left: 0;
  height: 39px;

  &::before,
  &::after {
    content: '';
    width: 90px;
    height: 2px;
    background: rgba(217, 217, 217, 0.86);
    opacity: 0.2;
    flex-shrink: 0;
  }

  &::before {
    margin-right: 16px;
  }

  &::after {
    margin-left: 16px;
  }

  ${tabletQuery} {
    flex-direction: column;
    height: auto;
    &::before,
    &::after {
      display: none;
    }
  }
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WaringText = styled.li`
  color: rgba(142, 142, 142, 0.48);
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.72px;
  position: relative;
  display: inline-block;

  &:after {
    content: '';
    width: 5px;
    height: 5px;
    background: rgba(142, 142, 142, 0.48);
    border-radius: 50%;
    position: absolute;
    left: -15px;
    top: 50%;
    transform: translateY(-50%);
  }
`;
